import { useNavigate } from "react-router-dom";
import urls from "../../../config/urls.json";
import { useSession } from "../../../hooks/useSession";
import { ApiService as api } from "../../../services/ApiService";
import { useStates } from "../../../hooks/useStates";
import { isCf } from "../../../services/validators";
import { useEffect, useState } from "react";
import { useEditAppointment } from "../../../hooks/useEditAppointment";
import { useDynatrace } from "../../../hooks/useDynatrace";

export const usePrestitoBusinessPage = () => {
  const navigate = useNavigate();
  const { read, update, batchUpdate } = useSession();
  const { states, setCurrentState, isDatiUtenteReady, isCfFetchStart, isCfFetchError, isCfEditAppointment } = useStates();
  const { showModal, closeModal, setCodiceFiscale, codiceFiscale, codiceFiscaleError, askForEditAppointment } = useEditAppointment();

  const [fetchError, setFetchError] = useState(false);
  const [fetchErrorMessage, setFetchErrorMessage] = useState("");

  useEffect(() => {
    setCurrentState(states.LOAD_FILIALI_SLIDES_END);
    update("codiceFiscale", "");
  }, []);

  const {} = useDynatrace();

  const goDatiPersonali = () => {
    navigate(urls.datiPersonaliNonRiconosciutoBusiness.path);
  };

  const setC5 = () => {
    update("prodotto", 3);
    navigate(urls.codiceFiscaleC5.path);
  }

  const setPrestitoPersonale = () => {
    update("prodotto", 1);
    navigate(urls.luogo.path);
  }

  const onCfChange = async (value) => {
    setCurrentState(states.BUSY);
    update("codiceFiscale", value);
    update("codiceFiscale_external", value); 

    if (value.length < 16) return;

    if (!isCf(value)) {
      setCurrentState(states.FETCH_CF_ERROR);
      return;
    }

    setCurrentState(states.FETCH_CF_START);

    let cfResult = {};
    try {
      cfResult = await api.GetUserDataAndAppointmentByCf({
        CodiceFiscale: value,
      }, 5);
    } catch (error) {
      setFetchErrorMessage("C'è stato un errore con il codice fiscale inserito. <br />Per favore riprova.");
      setFetchError(true);
      setCurrentState(states.LOAD_FILIALI_SLIDES_END);
      return;
    }

    // let's see if he has an appointment already
    update("oppID", "");

    const oppID = cfResult.appointmentData ? cfResult.appointmentData.oppID : null;
    if (null != oppID) {
      setCurrentState(states.FETCH_CF_EDIT_APPOINTMENT);
      askForEditAppointment();
      return;
    }

    update("ricontattoCf", false); //Da prestito business non torna ricontatto

    const utente = cfResult.datiCliente || {};
    const mergeableFields = {}; 
    mergeableFields["nome"] = utente.nome || "";
    mergeableFields["cognome"] = utente.cognome || "";
    mergeableFields["email"] = utente.email || "";
    mergeableFields["cellulare"] = utente.telefono || "";
    mergeableFields["capResidenza"] = utente.cap || "";

    batchUpdate(mergeableFields);
    setCurrentState(states.FETCH_CF_END);
  };

  const next = () => {
    goDatiPersonali();
  };

  const getCfInputState = () => {
    return isCfFetchError() ? 4 : isCf(read("codiceFiscale")) ? 3 : 1;
  };

  return {
    read,
    update,
    onCfChange,
    next,
    goDatiPersonali,
    isDatiUtenteReady,
    isCfFetchStart,
    isCfFetchError,
    isCfEditAppointment,
    getCfInputState,
    fetchErrorMessage,
    fetchError,
    setFetchError,
    showModal,
    closeModal,
    setCodiceFiscale,
    codiceFiscale,
    codiceFiscaleError,
    askForEditAppointment,
    setPrestitoPersonale,
    setC5
  };
};
